import c from "../../utils/constants";

class MediaController {
  constructor(MediaService, FilterService, $scope) {
    "ngInject"

    this.mediaService = MediaService;
    this.filterService = FilterService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  $onInit() {
    this.mediaReviewStatusOptions = {
      dataSource: [
        { value: 0, text: "Unspecified" },
        { value: 1, text: "Pending" },
        { value: 2, text: "Approved" },
        { value: 3, text: "Rejected" },
      ],
      dataTextField: "text",
      dataValueField: "value"
    }

  }

  getGridOptions() {

    return {
      dataSource: this.mediaService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      noRecords: {
        template: "No match found. Change your filter criteria."
      },
      columns: [
        { field: "creationDate", title: "Date", template: `<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>`, filterable: false, width: "6rem" },
        { title: "Name", template: `<a class="cell" href="#= '/users/' + userId #">#= firstName + " " + lastName #</a>`, filterable: false, sortable: false, width: "10rem" },
        // { field: "mediaStatus", title: "Media Status", filterable: false, sortable: false, width: "8rem" },
        { field: "mediaReviewStatus", title: "Review Status", filterable: false, sortable: true, width: "8rem", template: (dataItem) => `${this._getMediaReviewStatus(dataItem.mediaReviewStatus)}` },
        { field: "duration", title: "Duration in seconds", filterable: false, sortable: false, width: "6rem" },
        { title: "Watch Media", filterable: false, sortable: false, width: "6rem", template: `<a class="cell" target="_blank" href="#= '//jugglestreet.wistia.com/medias/' + externalHashedId #">Link to media</a>` },
        { title: "Update Review Status", command: [{ name: "edit", text: "Update" }], width: "7rem" },


      ],
      editable: {
        mode: "popup",
        window: { title: "Update Review Status" },
        template: kendo.template($("#popup-editor").html())
      }
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.mediaMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

  _getMediaReviewStatus(status) {

    switch (status) {
      case c.mediaReviewStatuts.UNSPECIFIED:
        return "Unspecified";
      case c.mediaReviewStatuts.PENDING:
        return "Pending";
      case c.mediaReviewStatuts.APPROVED:
        return "Approved";
      case c.mediaReviewStatuts.REJECTED:
        return "Rejected";
    }
  }

}

export default MediaController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/media/media.controller.js
 **/